function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "old-mobile");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#666666",
  d: "M13.6 3h-6.6v-3h-2v18.6c0 0.77 0.629 1.4 1.398 1.4h7.202c0.769 0 1.4-0.631 1.4-1.4v-14.199c0-0.772-0.631-1.401-1.4-1.401zM8 15c-0.691 0-1.25-0.447-1.25-1s0.559-1 1.25-1 1.25 0.447 1.25 1-0.559 1-1.25 1zM9.25 17c0 0.553-0.559 1-1.25 1s-1.25-0.447-1.25-1 0.559-1 1.25-1 1.25 0.447 1.25 1zM7 11v-6h6v6h-6zM12 15c-0.691 0-1.25-0.447-1.25-1s0.559-1 1.25-1 1.25 0.447 1.25 1-0.559 1-1.25 1zM13.25 17c0 0.553-0.559 1-1.25 1s-1.25-0.447-1.25-1 0.559-1 1.25-1 1.25 0.447 1.25 1z"
});

var SvgMobile = function SvgMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile.882b2bb2.svg";
export { ForwardRef as ReactComponent };